import React, { Component } from 'react'
import Button from '@material-ui/core/Button';
import { resetPassword } from './utilities/extraAPIs'

export default class ResetPass extends Component {
    state = { result: '' }

    onEmailChange = (event) => { this.setState({ forgotPassEmail: event.target.value }) }
    onUserNameChange = (event) => { this.setState({ forgotPassUserName: event.target.value }) }
    async onForgotOK(username, email) {
        this.setState({ result: '' })
        let result = await resetPassword(username, email)
        this.setState({ result })
    }

    render() {
        return <div>
            <div> <input placeholder='User Name' onChange={ this.onUserNameChange } /></div>
            <div>
                <input placeholder='Email' onChange={ this.onEmailChange } />
                <Button style={ { marginLeft: '10px' } } variant="contained" onClick={ () => this.onForgotOK(this.state.forgotPassUserName, this.state.forgotPassEmail) } color="secondary">ok</Button>
            </div>
            <div> <span style={ { color: 'red' } }>{ this.state.result }</span></div>
        </div>

    }
}